import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { PageWrapper } from "./styles";
import { progressSend } from "../utils/progress";
import { clientVersion, BaseURL } from "../utils/comm";

const GoButton = styled.div`
  color: white;
  background-color: blue;
  max-width: 8em;
  padding: 1px 5px;
  cursor: pointer;
  border-radius: 10px;
`;

let EmailWrapper = styled.div`
  /*  width: 350px; */
  border: 1px solid grey;
  border-radius: 5px;
  margin: auto;
  padding: 0em;
  line-height: 1.5em;
`;

const URLTail = () => {
  const pieces = BaseURL.split("/");
  return pieces[pieces.length - 1];
};

export const RUSure = ({ setFinished, surveyResult, incomingMessage }) => {
  const [errorMsg, setErrorMsg] = useState(incomingMessage);

  useEffect(() => {
    const sendProgress = async () => {
      await progressSend({
        event: "Start Screen",
        userEmail: "",
      });
    };
    sendProgress();
  }, []);

  const handleSubmit = async () => {
    // Validate email; Remove the "-test" (if present) for this regexp test
    let regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      !regexp.test(
        String(surveyResult.userEmail.split("-test")[0]).toLowerCase()
      )
    ) {
      setErrorMsg("Please specify a valid email address.");
      return;
    }
    if (surveyResult.userEmail.indexOf("-test") !== -1) {
      surveyResult.testMode = true;
      surveyResult.userEmail = surveyResult.userEmail.split("-test")[0];
      //("Test mode:" + surveyResult.userEmail);
    }
    progressSend({
      event: "Email accepted",
      userEmail: surveyResult.userEmail,
    }).then(() => setFinished("done"));
  };

  return (
    <PageWrapper>
      <div
        style={{
          width: "auto",
          margin: "auto",
          backgroundColor: "white",
          borderRadius: "5px",
          padding: "1em",
        }}
      >
        <p>
          The RootFinder Assessment from Complex Health Solutions is an
          extensive series of health-related questions that help determine the
          most likely underlying &quot;root causes&quot; of your health issues
          and symptoms. The analysis is based upon many years of clinical
          investigations covering over thirty potential root causes.
        </p>
        <p>
          For best results, we recommend setting aside 10 to 15 minutes of your
          time to answering the questions. Once you begin the Assessment, you
          will NOT be able to save your progress and return at a later time to
          where you left off. As you read each question, reflect on your past
          history, but with an emphasis on your current level of symptoms,
          indicate your response.
        </p>
        <p>
          Once you have completed the Assessment, you can pay and receive your
          personal root cause analysis report via email.
        </p>
        <EmailWrapper>
          <center>
            {/*
            <div
              style={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#375b99",
                marginBottom: "0.8em",
              }}
            >
              Visitors and Clients
            </div>
            */}
            Where should we send the results of your RootFinder Analysis report?
            <br></br>
            <input
              size={30}
              type="text"
              defaultValue={surveyResult.userEmail}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
              onChange={(e) => {
                surveyResult.userEmail = e.target.value;
              }}
            />
            {errorMsg && (
              <div
                style={{
                  color: "red",
                  fontSize: "1.2em",
                  marginTop: 10,
                  //marginBottom: "10px",
                }}
              >
                {errorMsg}
              </div>
            )}
            <p>
              <i>
                We never, at any time or in any way, sell, license, or provide
                email addresses to anyone for marketing purposes.
              </i>
              <div
                style={{
                  textAlign: "left",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <ul>
                  <li>Satisfaction guaranteed. </li>
                  <li>See our refund policy below under Terms of Service.</li>
                </ul>
                <div style={{ flexGrow: 1 }}></div>
              </div>
            </p>
            <p style={{ marginBottom: "0" }}>
              <GoButton
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                Continue
              </GoButton>
              <div
                style={{
                  fontSize: "0.7em",
                  marginTop: "1em",
                }}
              >
                Version {clientVersion + "-" + URLTail() + "-Node upgrade-14"}
              </div>
            </p>
          </center>
        </EmailWrapper>
      </div>
    </PageWrapper>
  );
};
